module.exports = __webpack_public_path__ + "static/Video_Thumbnail_teal-b290f7545b6e16bc19a77b0bc03c6ffd.png";